<app-stages [stages]="stages" currentStage="Treść wniosku"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <fieldset>
      <legend>
        Dane działki
      </legend>
      <div class="row">
        <div class="col-md-4">
          <div class='form-group' *ngIf='"precint" as controlName'>
            <label [for]='controlName'>Obręb *</label>
            <select
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [id]='controlName'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option *ngFor='let item of form.obrebList()' [value]='item?.name'>
                {{ item?.name }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"registrationNumber" as controlName'>
            <label [for]='controlName'>
              Działka nr *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nr działki'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"landRegister" as controlName'>
            <label [for]='controlName'>
              Numer Księgi Wieczystej *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nr księgi wieczystej'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Dane właścicieli/a działki
      </legend>
      <div class="row">
        <div class="col-12">
          <app-alert type="warning" alertTitle="Uwaga:" [closable]="false">
            w przypadku wielu właścicieli proszę wpisać <strong>po przecinku</strong> lub wcisnąć
            <strong>enter</strong>
          </app-alert>
        </div>
        <div class="col-12">
          <div class='form-group' *ngIf='"personFullName" as controlName'>
            <label [for]='controlName'>
              Imię nazwisko / Nazwa *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu dane właścicieli/a działki'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Podziału przedmiotowej nieruchomości dokonuje się na podstawie przepisu artykułu
      </legend>
      <br>
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"article" as controlName'>
            @for (article of articleList(); track $index) {
              <div class="custom-radio" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                <input
                  (change)="form.articleChange(article)"
                  [formControlName]="controlName"
                  type="radio"
                  [id]="'article_' + ($index + 1)"
                  [value]="article">
                <label [for]="'article_' + ($index + 1)">{{ article }}</label>
              </div>
            }
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.divisionOfRealEstateArticle95) {
          <div class="col-12">
            <p>
              <strong>
                Artykuł 95 punkty 1-8 (wybierz który dotyczy):
              </strong>
            </p>
            <br>
            <div class='form-group' *ngIf='"divisionOfRealEstateArticle95" as controlName'>
              @for (item of form.divisionOfRealEstateArticle95List; track $index) {
                <div class="custom-radio" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                  <input
                    [formControlName]="controlName"
                    type="radio"
                    [id]="controlName + ($index + 1)"
                    [value]="item">
                  <label [for]="controlName + ($index + 1)">{{ item }}</label>
                </div>
              }
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.otherArticleDescription) {
          <div class="col-12">
            <div class='form-group' *ngIf='"otherArticleDescription" as controlName'>
              <label [for]='controlName'>
                Inna podstawa prawna *
              </label>
              <textarea
                rows="4"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu podstawę prawną'>
            </textarea>
              <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Informacje o wydzielanych działkach
      </legend>
      <app-parcels-crud
        [accessControl]="true"
        [landUseControl]="true"
        [hideContentControl]="true"
        formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
      <span>
        Wstecz
      </span>
      </button>
      <button
        type='button'
        class='btn btn-primary'
        (click)='submitAndGoNext()'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
